// src/components/WhatsAppButton.js
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  // Numéro de téléphone formaté pour WhatsApp
  const phoneNumber = '33695744027';
  // Message par défaut (optionnel)
  const defaultMessage = "Bonjour, je souhaite obtenir des informations sur les inscriptions.";

  // Construire l'URL WhatsApp
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contacter sur WhatsApp"
    >
      <FaWhatsapp className="whatsapp-icon" />
      <span className="whatsapp-tooltip">Nous contacter sur WhatsApp</span>
      <span className="whatsapp-pulse"></span>
    </a>
  );
};

export default WhatsAppButton;